<div class="agents-container">
    <!-- Header Section -->
    <div class="agents-header">
        <div class="header-left">
            <img src="./assets/images/icons/dashboard/user_card_red.png" alt="user card Icon" class="file-icon">
            <span class="header-title">
                <span class="title-text">Agents / <strong class="username">{{ isEditMode ? "Modifier l'agent" : "Création d'un agent" }}</strong></span>
            </span>
        </div>

        <div class="header-right">
            <button class="back-btn" (click)="goToList()">
                <img src="assets/images/icons/back-arrow.png" alt="back" class="back-icon">
                <span>Retour à la liste</span>
            </button>
        </div>
    </div>

    <div class="agent-form-container">
        <!-- Success Message -->
        <div *ngIf="showSuccess" class="success-message">
            <div class="success-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="#4CB86E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                </svg>
            </div>
            <p>{{ successMessage }}</p>
            <div class="success-actions">
                <button *ngIf="!isEditMode" type="button" class="btn btn-primary" (click)="createAnother()">
                    Créer un autre agent
                </button>
                <button type="button" class="btn btn-cancel" (click)="goToList()">
                    Retour à la liste
                </button>
            </div>
        </div>

        <!-- Loading State -->
        <div *ngIf="isLoading" class="loading-state">
            <div class="loading-spinner"></div>
            <p>Chargement des informations de l'agent...</p>
        </div>

        <!-- Main Form -->
        <form *ngIf="!showSuccess && !isLoading" [formGroup]="agentForm" (ngSubmit)="onSubmit()" class="agent-form">
            <!-- Profile Image Upload -->
            <div class="form-section">
                <h3 class="section-title">Photo de profil</h3>
                <div class="profile-upload-area" [class.has-file]="selectedFile || previewUrl">
                    <div class="profile-image-container" (click)="fileInput.click()">
                        <div *ngIf="previewUrl" class="image-preview">
                            <img [src]="previewUrl" alt="Profile Preview" class="preview-image">
                        </div>
                        <div *ngIf="!previewUrl" class="upload-placeholder" (click)="onFileSelected($event)">
                            <img src="assets/images/icons/upload.png" alt="Upload" class="upload-icon">
                            <p class="upload-text">Ajouter une photo</p>
                            <p class="upload-hint">JPG, PNG (max 5MB)</p>
                        </div>
                        <input #fileInput type="file" accept="image/*" (change)="onFileSelected($event)" class="file-input" hidden>
                    </div>
                    <div class="profile-upload-actions">
                        <button *ngIf="previewUrl" type="button" class="btn btn-sm" (click)="removeFile()">
                            Supprimer
                        </button>
                    </div>
                </div>
            </div>

            <!-- Personal Information Section -->
            <div class="form-section mb-0">
                <h3 class="section-title">Informations personnelles</h3>
                <div class="form-row">
                    <div class="form-group">
                        <label for="firstName">Prénom *</label>
                        <input type="text" id="firstName" formControlName="firstName" class="form-control" [class.is-invalid]="firstName?.invalid && firstName?.touched" placeholder="Entrez le prénom">
                        <div *ngIf="firstName?.invalid && firstName?.touched" class="form-error">
                            <span *ngIf="firstName?.errors?.['required']">Le prénom est obligatoire</span>
                            <span *ngIf="firstName?.errors?.['minlength']">Le prénom doit contenir au moins 2 caractères</span>
                            <span *ngIf="firstName?.errors?.['maxlength']">Le prénom ne doit pas dépasser 100 caractères</span>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="lastName">Nom *</label>
                        <input type="text" id="lastName" formControlName="lastName" class="form-control" [class.is-invalid]="lastName?.invalid && lastName?.touched" placeholder="Entrez le nom">
                        <div *ngIf="lastName?.invalid && lastName?.touched" class="form-error">
                            <span *ngIf="lastName?.errors?.['required']">Le nom est obligatoire</span>
                            <span *ngIf="lastName?.errors?.['minlength']">Le nom doit contenir au moins 2 caractères</span>
                            <span *ngIf="lastName?.errors?.['maxlength']">Le nom ne doit pas dépasser 100 caractères</span>
                        </div>
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group">
                        <label for="email">Email *</label>
                        <input type="email" id="email" formControlName="email" class="form-control" [class.is-invalid]="email?.invalid && email?.touched" placeholder="Ex: agent@example.com">
                        <div *ngIf="email?.invalid && email?.touched" class="form-error">
                            <span *ngIf="email?.errors?.['required']">L'email est obligatoire</span>
                            <span *ngIf="email?.errors?.['email']">Format d'email invalide</span>
                            <span *ngIf="email?.errors?.['maxlength']">L'email ne doit pas dépasser 255 caractères</span>
                        </div>
                        <div *ngIf="emailAlreadyExists" class="form-error">
                            <span>Cet email est déjà utilisé par un autre agent</span>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="phoneNumber">Téléphone *</label>
                        <input type="tel" id="phoneNumber" formControlName="phoneNumber" class="form-control" [class.is-invalid]="phoneNumber?.invalid && phoneNumber?.touched" placeholder="Ex: +33 1 23 45 67 89">
                        <div *ngIf="phoneNumber?.invalid && phoneNumber?.touched" class="form-error">
                            <span *ngIf="phoneNumber?.errors?.['required']">Le téléphone est obligatoire</span>
                            <span *ngIf="phoneNumber?.errors?.['pattern']">Format de téléphone invalide</span>
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group">
                        <label for="birthDate">Date de naissance</label>
                        <input type="date" id="birthDate" formControlName="birthDate" class="form-control">
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group">
                        <label for="weight">Poids (kg)</label>
                        <input type="number" id="weight" formControlName="weight" class="form-control" [class.is-invalid]="weight?.invalid && weight?.touched" placeholder="Ex: 70" min="20" max="300" step="0.1">
                        <div *ngIf="weight?.invalid && weight?.touched" class="form-error">
                            <span *ngIf="weight?.errors?.['min']">Le poids minimum est 20kg</span>
                            <span *ngIf="weight?.errors?.['max']">Le poids maximum est 300kg</span>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="height">Taille (cm)</label>
                        <input type="number" id="height" formControlName="height" class="form-control" [class.is-invalid]="height?.invalid && height?.touched" placeholder="Ex: 175" min="100" max="250" step="0.1">
                        <div *ngIf="height?.invalid && height?.touched" class="form-error">
                            <span *ngIf="height?.errors?.['min']">La taille minimum est 100cm</span>
                            <span *ngIf="height?.errors?.['max']">La taille maximum est 250cm</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Professional Information Section -->
            <div class="form-section">
                <h3 class="section-title">Informations professionnelles</h3>
                <div class="form-row">
                    <div class="form-group">
                        <label for="specialization">Spécialisation *</label>
                        <input type="text" id="specialization" formControlName="specialization" class="form-control" [class.is-invalid]="specialization?.invalid && specialization?.touched" placeholder="Ex: Sécurité, Service, Animation">
                        <div *ngIf="specialization?.invalid && specialization?.touched" class="form-error">
                            <span *ngIf="specialization?.errors?.['required']">La spécialisation est obligatoire</span>
                            <span *ngIf="specialization?.errors?.['maxlength']">La spécialisation ne doit pas dépasser 100 caractères</span>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="yearsOfExperience">Années d'expérience *</label>
                        <input type="number" id="yearsOfExperience" formControlName="yearsOfExperience" class="form-control" [class.is-invalid]="yearsOfExperience?.invalid && yearsOfExperience?.touched" placeholder="Ex: 5" min="0" max="50">
                        <div *ngIf="yearsOfExperience?.invalid && yearsOfExperience?.touched" class="form-error">
                            <span *ngIf="yearsOfExperience?.errors?.['required']">Les années d'expérience sont obligatoires</span>
                            <span *ngIf="yearsOfExperience?.errors?.['min']">Le minimum est 0</span>
                            <span *ngIf="yearsOfExperience?.errors?.['max']">Le maximum est 50</span>
                        </div>
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group">
                        <label for="hourlyRate">Taux horaire (€)</label>
                        <input type="number" id="hourlyRate" formControlName="hourlyRate" class="form-control" [class.is-invalid]="hourlyRate?.invalid && hourlyRate?.touched" placeholder="Ex: 25.50" min="0" max="1000" step="0.01">
                        <div *ngIf="hourlyRate?.invalid && hourlyRate?.touched" class="form-error">
                            <span *ngIf="hourlyRate?.errors?.['min']">Le taux minimum est 0€</span>
                            <span *ngIf="hourlyRate?.errors?.['max']">Le taux maximum est 1000€</span>
                        </div>
                    </div>

                    <div class="form-group">
                        <label>Disponibilité *</label>
                        <div class="availability-toggle">
                            <button type="button" class="toggle-btn" [class.active]="isAvailable?.value === true" (click)="agentForm.get('isAvailable')?.setValue(true)">
                                <span class="status-dot available"></span>
                                Disponible
                            </button>
                            <button type="button" class="toggle-btn" [class.active]="isAvailable?.value === false" (click)="agentForm.get('isAvailable')?.setValue(false)">
                                <span class="status-dot unavailable"></span>
                                Indisponible
                            </button>
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <label for="bio">Biographie</label>
                    <textarea id="bio" formControlName="bio" class="form-control textarea" rows="4" [class.is-invalid]="bio?.invalid && bio?.touched" placeholder="Décrivez l'expérience, les compétences et les qualifications de l'agent... (max 500 caractères)" maxlength="500"></textarea>
                    <div *ngIf="bio?.invalid && bio?.touched" class="form-error">
                        <span *ngIf="bio?.errors?.['maxlength']">La biographie ne doit pas dépasser 500 caractères</span>
                    </div>
                    <div class="helper-container">
                        <div class="help-text">
                            Cette biographie sera visible par l'admin et par les clients lors de l'attribution des réservations
                        </div>
                        <div class="char-counter">
                            {{ bio?.value?.length || 0 }}/500
                        </div>
                    </div>
                </div>
            </div>

            <!-- Address Information Section -->
            <div class="form-section mb-0" [formGroup]="addressForm">
                <h3 class="section-title">Adresse</h3>
                <div class="form-row">
                    <div class="form-group">
                        <input type="text" id="streetNumber" formControlName="streetNumber" class="form-control" [class.is-invalid]="streetNumber?.invalid && streetNumber?.touched" placeholder="Numéro et nom de la rue">
                        <div *ngIf="streetNumber?.invalid && streetNumber?.touched" class="form-error">
                            <span *ngIf="streetNumber?.errors?.['required']">L'adresse est obligatoire</span>
                            <span *ngIf="streetNumber?.errors?.['maxlength']">L'adresse ne doit pas dépasser 200 caractères</span>
                        </div>
                    </div>

                    <div class="form-group">
                        <input type="text" id="street" formControlName="street" class="form-control" [class.is-invalid]="street?.invalid && street?.touched" placeholder="Complément d'adresse (appartement, étage...)">
                        <div *ngIf="street?.invalid && street?.touched" class="form-error">
                            <span *ngIf="street?.errors?.['maxlength']">L'adresse ne doit pas dépasser 200 caractères</span>
                        </div>
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group">
                        <label for="city">Ville *</label>
                        <input type="text" id="city" formControlName="city" class="form-control" [class.is-invalid]="city?.invalid && city?.touched" placeholder="Ex: Bruxelles">
                        <div *ngIf="city?.invalid && city?.touched" class="form-error">
                            <span *ngIf="city?.errors?.['required']">La ville est obligatoire</span>
                            <span *ngIf="city?.errors?.['maxlength']">La ville ne doit pas dépasser 100 caractères</span>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="postalCode">Code postal *</label>
                        <input type="text" id="postalCode" formControlName="postalCode" class="form-control" [class.is-invalid]="postalCode?.invalid && postalCode?.touched" placeholder="Ex: 1040">
                        <div *ngIf="postalCode?.invalid && postalCode?.touched" class="form-error">
                            <span *ngIf="postalCode?.errors?.['required']">Le code postal est obligatoire</span>
                            <span *ngIf="postalCode?.errors?.['pattern']">Format de code postal invalide (4-10 chiffres)</span>
                        </div>
                    </div>

                </div>
            </div>

            <!-- Form Actions -->
            <div class="form-actions">
                <button type="submit" class="btn btn-primary btn-block" [disabled]="isSubmitting || agentForm.invalid">
                    <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-2"></span>
                    {{ isSubmitting ? 'Enregistrement...' : (isEditMode ? 'Modifier l\'agent' : 'Créer l\'agent') }}
                </button>
                <button type="button" class="btn btn-cancel" (click)="goToList()">
                    Annuler
                </button>
            </div>
        </form>
    </div>
</div>